import React from 'react';

function PageTransition({ children }) {
  return (
    <div className="page-transition">
      {children}
    </div>
  );
}

export default PageTransition;
